import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { Routes, Route, Navigate } from "react-router-dom";
import useLangNavigate from "../hooks/useLangNavigate";
import {
  setUser,
  setRestaurantId,
  setUserRestaurants,
  clearUser,
} from "../redux/slices/userSlice";
import {
  setCreationDate,
  clearRestaurant,
} from "../redux/slices/restaurantsSlice";
import { stopAllControlling } from "../redux/slices/adminSlice";
import { DemoProvider } from "../contexts/DemoContext";
import Dashboard from "./Dashboard";
import restaurantData from "../data/demo/restaurant.json";
import Spinner from "../components/utils/Spinner";

const DemoDashboard = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const navigate = useLangNavigate();
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    // Initialize demo user state
    const demoUser = {
      userId: 999,
      firstname: "Marco",
      lastname: "Rossi",
      username: "demo.restaurant",
      email: "demo@trattoria-demo.ch",
      phone: "+41 91 123 45 68",
      is2FA: false,
      isPasswordResetRequired: false,
      occupiedFunction: "Manager",
      roles: [
        {
          roleId: 2,
          label: "restaurantAdmin",
        },
      ],
      language: localStorage.getItem("i18nextLng")?.split("-")[0] || "en",
      fullImagePath: null,
      restaurants: [
        {
          restaurantId: restaurantData.restaurantId,
          name: restaurantData.name,
          address: restaurantData.address,
          phone: restaurantData.phone,
          email: restaurantData.email,
          images: restaurantData.images,
          consumptionmodes: restaurantData.consumptionmodes,
          restauranttype: restaurantData.restauranttype,
        },
      ],
      restaurantId: restaurantData.restaurantId,
      companies: [],
      token: "demo-token",
      apiKey: "demo-api-key",
    };

    // Set user state
    dispatch(setUser(demoUser));
    dispatch(setRestaurantId(restaurantData.restaurantId));
    dispatch(setUserRestaurants([demoUser.restaurants[0]]));
    dispatch(setCreationDate(restaurantData.createdAt));

    // Mark as initialized
    setIsInitialized(true);

    // Cleanup on unmount - clear all demo-related state
    return () => {
      // Clear Redux state
      dispatch(clearUser());
      dispatch(clearRestaurant());
      dispatch(stopAllControlling());
    };
  }, [dispatch]);

  if (!isInitialized) {
    return <Spinner />;
  }

  return (
    <DemoProvider>
      <div className="demo-dashboard">
        <div className="demo-banner">
          <div className="demo-banner-content">
            <span className="demo-banner-icon">🎯</span>
            <span className="demo-banner-text">
              <strong>{t("demo.banner.title")}</strong> -{" "}
              {t("demo.banner.description")}
            </span>
            <button
              type="button"
              onClick={() => navigate("/")}
              className="demo-banner-link"
            >
              {t("demo.banner.learnMore")}
            </button>
          </div>
        </div>
        <Routes>
          <Route path="/" element={<Navigate to="dashboard" replace />} />
          <Route path="dashboard/*" element={<Dashboard />} />
        </Routes>
      </div>
    </DemoProvider>
  );
};

export default DemoDashboard;
